import { useState, useEffect } from "react";
import { Icon } from "../assets";
import useDeviceType from "../Utiles/FindDevice";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserInfo(parsedUserInfo?.userLogedIn);
      } catch (error) {
        setUserInfo(null);
      }
    } else {
      setUserInfo(null);
    }
  }, []);

  const contactLink = userInfo ? "/help" : "/contactUs";
  const contactText = userInfo ? "Help" : "Contact Us";
  const howToPlay = userInfo ? "/how-to-play" : "/how-to-play";

  return (
    <section className="bg-[#002042] px-4 md:px-6 w-full py-4">
      <div className="mx-auto py-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0">
          {deviceType === "mobile" ?
            <div className="text-sm md:text-base font-medium text-white text-center md:text-left">
              <p>© Copyrights</p>
              <p>Reserved <span className="text-[#00C05B]">@SureShotSports FZ-LLC</span></p>
            </div> : <div className="text-sm md:text-base font-medium text-white text-center md:text-left">
              © Copyrights Reserved{" "}
              <span className="text-[#00C05B]">@SureShotSports FZ-LLC</span>
            </div>}
          <div className="flex items-center gap-3 text-sm md:text-base text-white/60 flex-wrap justify-center">
            <div>
              <a
                href="/how-yo-play"
                onClick={
                  (e) => {
                    e.preventDefault();
                    sessionStorage.setItem("landingVisited", "true")
                    navigate("/how-to-play")
                  }
                }
                className="hover:text-white transition-colors cursor-pointer"
              >
                How to Play
              </a>
            </div>

            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div>
              <a
                href="/termsAndConditions"
                onClick={
                  (e) => {
                    e.preventDefault();
                    sessionStorage.setItem("landingVisited", "true")
                    navigate("/termsAndConditions")
                  }
                }
                className="hover:text-white transition-colors cursor-pointer"
              >
                Terms & Conditions
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div>
              <a 
                href="/rules"
                onClick={
                  (e) => {
                    e.preventDefault();
                    sessionStorage.setItem("landingVisited", "true")
                    navigate("/rules")
                  }
                } 
                className="hover:text-white transition-colors cursor-pointer">
                Responsible Gaming
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div>
              <a
                onClick={
                  (e) => {
                    e.preventDefault();
                    sessionStorage.setItem("landingVisited", "true")
                    navigate("/privacyPolicy")
                  }
                }
                href="/privacyPolicy"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Privacy & Cookie Policy
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div className="flex items-center gap-2">
              <a
                onClick={
                  (e) => {
                    e.preventDefault();
                    sessionStorage.setItem("landingVisited", "true")
                    navigate(contactLink)
                  }
                }
                href={contactLink}
                className="hover:text-white transition-colors cursor-pointer"
              >
                {contactText}
              </a>
              <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto hidden md:block xl:hidden" />
            </div>
            <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto hidden lg:hidden xl:block" />
          </div>
        </div>
        <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto block md:hidden" />
      </div>
    </section>
  );
}
